"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomTheme = void 0;

var _themeConstants = require("./themeConstants");

var getCustomTheme = function getCustomTheme(theme) {
  var themeToRender = _themeConstants.AVAILABLE_THEMES[theme] || _themeConstants.AVAILABLE_THEMES.defaultTheme;
  return {
    themeToRender: themeToRender
  };
};

exports.getCustomTheme = getCustomTheme;